<script>
    import AggregatedReviewScore from "$components/AggregatedReviewScore.svelte";

    export let highlight = false;

    export let name;
    export let address;
    export let neighbourhood;
    export let aggregatedScore;

    let highlightClass = 'cta !text-white ring-[rgba(0, 0, 0, 0.1)] ring-[3px] ring-inset'
</script>

<div
    class='card {highlight ? highlightClass : ""} w-full my-1 min-h-[25px] bg-white border-neutral-50 hover:border-primary-200 border-[1px] rounded-3xl px-3  hover:shadow-lg' >
    <header class='card-header flex flex-col justify-between h-full pb-5'>
        <p class='building-name {highlight ? "!text-white" : ""} text-lg font-bold truncate'>{@html name}</p>
        <div class="flex flex-row items-center justify-between gap-3 mt-2">
            <div>
                {#if address}
                    <p class='building-address text-md font-light {highlight ? "!text-white" : "text-neutral-400"}'>{@html address}</p>
                {/if}
                {#if neighbourhood}
                    <p class='building-neighbourhood text-md font-light {highlight ? "!text-white" : "text-neutral-400"}'>{neighbourhood}</p>
                {/if}
            </div>
            {#if aggregatedScore}
                <AggregatedReviewScore reviewScore={aggregatedScore?.score} size="medium" />
            {:else}
                <p class='text-3xl'>&nbsp;</p>
            {/if}
        </div>
    </header>
</div>


<style>
    .card:hover .building-name {
        @apply text-primary-500;
    }

    .card:hover .building-address, .card:hover .building-neighbourhood {
        @apply text-neutral-600;
    }

    .card, .building-name, .building-address, .building-neighbourhood {
        @apply transition-all duration-150;
    }
</style>
